import * as React from "react";
import styled from "styled-components";
import { Label } from "components/bootstrap";
const Td = styled.td`
  max-width: 300px;
`;
const Role = styled(Label)`
  margin-right: 5px;
  margin-bottom: 5px;
  display: inline-block;
`;
const RolesCell = ({ roles }) => /* @__PURE__ */ React.createElement(Td, null, roles.map((role) => /* @__PURE__ */ React.createElement(Role, { key: role, bsStyle: role === "Admin" ? "info" : "default" }, role)).toArray());
export default RolesCell;
